import { useState, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { HttpData, HttpNoData } from "../../../../Core";

export default function MaterialModalEdit({
  jwt,
  material,
  show,
  onHide,
  onUpdated,
  onDeleted,
}) {
  const [name, setName] = useState("");

  useEffect(() => {
    if (material) {
      setName(material.name || "");
    }
  }, [material]);

  const onSubmit = async (e) => {
    e.preventDefault();
    const response = await HttpData(
      `/api/v1/calculateOrderCost/materials/${material.id}`,
      "PUT",
      jwt,
      {
        name: name,
      },
    );

    if (response.statusSuccessful) {
      onUpdated({
        ...material,
        name: name,
      });
      onHide();
    } else {
      alert(`Не получилось обновить: ${response.error}`);
    }
  };

  const onDelete = async () => {
    if (!window.confirm("Вы уверены, что хотите удалить этот материал?"))
      return;

    const response = await HttpNoData(
      `/api/v1/calculateOrderCost/materials/${material.id}`,
      "DELETE",
      jwt,
    );

    if (response.statusSuccessful) {
      onDeleted();
      onHide();
    } else {
      alert(`Не получилось удалить: ${response.error}`);
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Form onSubmit={onSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Редактирование материала</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Название материала</Form.Label>
            <Form.Control
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Отмена
          </Button>
          <Button variant="danger" onClick={onDelete}>
            Удалить
          </Button>
          <Button variant="success" type="submit">
            Сохранить
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
